var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoParticipants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.001,
    height: 40.001,
    viewBox: "0 0 40.001 40.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.535 10.534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.411,27.882a.294.294,0,0,1-.294-.294V25.823a3.239,3.239,0,0,0-3.235-3.235H4.823a3.235,3.235,0,0,0-3.235,3.235v1.765a.294.294,0,0,1-.588,0V25.823A3.823,3.823,0,0,1,4.823,22h7.059a3.828,3.828,0,0,1,3.823,3.823v1.765A.294.294,0,0,1,15.411,27.882Z",
    transform: "translate(-0.867 -11.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.345,27.949a.428.428,0,0,1-.427-.427V25.757a3.105,3.105,0,0,0-3.1-3.1H4.757a3.1,3.1,0,0,0-3.1,3.1v1.765a.427.427,0,0,1-.855,0V25.757A3.957,3.957,0,0,1,4.757,21.8h7.059a3.961,3.961,0,0,1,3.957,3.957v1.765A.428.428,0,0,1,15.345,27.949ZM4.757,22.388h7.059a3.372,3.372,0,0,1,3.369,3.369v1.765a.161.161,0,0,0,.322,0V25.757a3.694,3.694,0,0,0-3.69-3.69H4.757a3.69,3.69,0,0,0-3.69,3.69v1.765a.161.161,0,0,0,.322,0V25.757a3.369,3.369,0,0,1,3.369-3.369Z",
    transform: "translate(-0.8 -11.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.823,4A3.823,3.823,0,1,1,7,7.823,3.828,3.828,0,0,1,10.823,4Zm0,7.059A3.235,3.235,0,1,0,7.588,7.823,3.239,3.239,0,0,0,10.823,11.059Z",
    transform: "translate(-3.337 -3.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.757,3.8A3.957,3.957,0,1,1,6.8,7.757,3.961,3.961,0,0,1,10.757,3.8Zm0,7.647a3.69,3.69,0,1,0-3.69-3.69A3.694,3.694,0,0,0,10.757,11.447Zm0-7.059A3.369,3.369,0,1,1,7.388,7.757,3.372,3.372,0,0,1,10.757,4.388Zm0,6.47a3.1,3.1,0,1,0-3.1-3.1A3.105,3.105,0,0,0,10.757,10.859Z",
    transform: "translate(-3.271 -3.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.441,27.962a.294.294,0,0,1-.294-.294V25.9a3.235,3.235,0,0,0-2.426-3.13.294.294,0,1,1,.147-.57,3.823,3.823,0,0,1,2.868,3.7v1.765A.294.294,0,0,1,32.441,27.962Z",
    transform: "translate(-12.602 -11.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.374,28.029a.428.428,0,0,1-.427-.427V25.837a3.1,3.1,0,0,0-2.326-3,.427.427,0,1,1,.214-.828A3.957,3.957,0,0,1,32.8,25.837V27.6A.428.428,0,0,1,32.374,28.029Zm-2.647-5.768a.161.161,0,0,0-.04.317,3.368,3.368,0,0,1,2.526,3.259V27.6a.161.161,0,0,0,.322,0V25.837a3.69,3.69,0,0,0-2.768-3.57A.162.162,0,0,0,29.727,22.262Z",
    transform: "translate(-12.536 -11.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.794,11.621a.294.294,0,0,1-.073-.579,3.235,3.235,0,0,0,0-6.268.294.294,0,1,1,.146-.57,3.823,3.823,0,0,1,0,7.408A.3.3,0,0,1,23.794,11.621Z",
    transform: "translate(-10.132 -3.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.727,11.688a.427.427,0,0,1-.106-.842,3.1,3.1,0,0,0,0-6.01.427.427,0,1,1,.212-.828,3.957,3.957,0,0,1,0,7.666A.429.429,0,0,1,23.727,11.688Zm0-7.426a.161.161,0,0,0-.04.317,3.369,3.369,0,0,1,0,6.527.161.161,0,1,0,.08.312,3.69,3.69,0,0,0,0-7.15A.162.162,0,0,0,23.727,4.262Z",
    transform: "translate(-10.065 -3.881)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoParticipants);
export default __webpack_public_path__ + "static/media/ico-participants.350a1c523f05bbcb4b8481f310a221b7.svg";
export { ForwardRef as ReactComponent };